const PII_KEYS = new Set([
  'pan', 'aadhaar', 'aadhar', 'otp', 'mpin', 'pin', 'email', 'mobile',
  'phone', 'account_number', 'accountnumber', 'bank_account', 'ifsc',
  'password', 'token', 'access_token', 'refresh_token', 'accesstoken',
  'refreshtoken', 'dob', 'date_of_birth', 'address', 'name', 'username',
  'user_name', 'secret', 'card_number', 'cvv', 'expiry', 'auth',
]);

const MAX_KEY_LEN = 40;
const MAX_STR_LEN = 100;

function isPII(key) {
  const lk = key.toLowerCase().replace(/[^a-z0-9_]/g, '_');
  return PII_KEYS.has(lk) || [...PII_KEYS].some((p) => lk === p || lk.endsWith('_' + p) || lk.startsWith(p + '_'));
}

export function sanitizeParams(params = {}) {
  if (!params || typeof params !== 'object') return {};
  const out = {};
  for (const [key, val] of Object.entries(params)) {
    if (isPII(key)) continue;
    const safeKey = key.toLowerCase().replace(/[^a-z0-9_]/g, '_').slice(0, MAX_KEY_LEN);
    let safeVal = val;
    if (typeof val === 'string') safeVal = val.slice(0, MAX_STR_LEN);
    else if (val !== null && typeof val === 'object') safeVal = JSON.stringify(val).slice(0, MAX_STR_LEN);
    out[safeKey] = safeVal;
  }
  return out;
}

export function classifyApiError(status) {
  if (!status || status === 'FETCH_ERROR' || status === 0) return 'network_error';
  if (status === 401) return 'auth_error';
  if (status === 403) return 'permission_error';
  if (status === 404) return 'not_found';
  if (status === 422) return 'validation_error';
  if (status >= 500) return 'server_error';
  if (status >= 400) return 'client_error';
  return 'unknown';
}

export function endpointToFeature(url = '') {
  if (url.includes('/auth/')) return 'auth';
  if (url.includes('/kyc')) return 'kyc';
  if (url.includes('/bank')) return 'bank_linking';
  if (url.includes('/nominee')) return 'nominee';
  if (url.includes('/invest')) return 'investment';
  if (url.includes('/redeem')) return 'redemption';
  if (url.includes('/mandate')) return 'mandate';
  if (url.includes('/sip') || url.includes('/stp') || url.includes('/swp')) return 'systematic_investment';
  if (url.includes('/mutual-fund') || url.includes('/mf')) return 'mutual_funds';
  if (url.includes('/portfolio')) return 'portfolio';
  if (url.includes('/notification')) return 'notifications';
  if (url.includes('/profile') || url.includes('/customer')) return 'profile';
  if (url.includes('/dashboard')) return 'dashboard';
  return 'general';
}
